// import { Icon as LegacyIcon } from '@ant-design/compatible';
import { Checkbox, DatePicker, Input, InputNumber, Radio, Select, Switch } from 'antd';
import React, { CSSProperties, FC, useMemo } from 'react';
import TextArea from 'antd/lib/input/TextArea';
import { FormInstance } from 'antd/lib/form';
import { TypeAdapter, ValidationAdapter } from '../Form';
import ConverterComponent from './ConverterComponent';
import ImageUploader from './imageUploader';
import SelectSearch from './selectSearch';
import EnumLoader from './enumLoader';
import { AvatarUploader, CroppedImageUploader, FileUpload } from './FileUpload';
import { AutoCompleteInput } from './AutoCompleteInput';
import HtmlTemplateInput from '../../components/HtmlTemplate/HtmlTemplateInput';
import SelectStatus from './selectStatus';
import { RichText } from '../../components/RichText/RichText';
import dayjs from 'dayjs';
// import CroppedImageInput from '../../customComponents/CroppedImageInput';
// import PhoneInput, { isValidPhoneNumber, PhoneInputProps } from 'react-phone-number-input';
// import FileUploadEx from '../../customComponents/FileUpload';
// import HtmlTemplateInput from '../../customComponents/HtmlTemplate/HtmlTemplateInput';
// import AutoCompleteInput from '../../customComponents/AutoCompleteInput';
// import MultiLanguageLineInput from '../../components/atoms/multilang-input/MultiLanguageLineInput';
// import MultiLanguageTextInput from '../../components/atoms/multilang-input/MultiLanguageTextInput';
// import JsonEditor from '../../components/atoms/json-editor/JsonEditor';
// import LocationPicker, {
//   AddressPicker
// } from '../../customComponents/LocationPicker/LocationPicker';
// import { ImagesInput } from '../../customComponents/ImagesInput/ImagesInput';
// import { EnumInput } from '../../customComponents/EnumInput';
// import UserSelect from '../../customComponents/UserSelector/UserSelect';
// import SupplierSelect from '../../customComponents/SupplierSelect/SupplierSelect';

type BooleanInputProps = { value?: boolean; onChange?: (value?: boolean) => void };
// tslint:disable-next-line:variable-name
export const BooleanInput: FC<BooleanInputProps> = (props) => {
  return (
    <Checkbox
      checked={props.value === true}
      onChange={(e) => props.onChange && props.onChange(e.target.checked)}>
      {props.children}
    </Checkbox>
  );
};

// type PhoneInputExProps = {
//   value?: string;
//   onChange?: (value?: string) => void;
// } & Partial<PhoneInputProps>;
// export const PhoneInputEx: FC<PhoneInputExProps> = (props) => {
//   const onChange = useCallback(
//     (value) => {
//       props.onChange?.(value === '' ? undefined : value);
//     },
//     [props]
//   );
//   return <PhoneInput {...props} onChange={onChange} value={props.value ?? ''} />;
// };

// // tslint:disable-next-line:variable-name
// constant ColorPicker: FC<{ value?: string; onChange: (value?: string) => void }> = (props) => {
//   constant [color, setColor] = useState<Color>();
//   useEffect(() => {
//     setColor(props.value);
//   }, []);
//
//   return (
//     <SwatchesPicker
//       color={color}
//       onChange={(c) => {
//         setColor(c.hex);
//         props.onChange && props.onChange(c.hex);
//       }}
//     />
//   );
// };

export default class CommonAdapters {
  // static validatePhone = (rule: any, value: any, callback: (a?: string) => void) => {
  //   if (!value || isValidPhoneNumber(value)) {
  //     callback();
  //   } else {
  //     callback('Invalid phone number');
  //   }
  // };

  static all(mobile: boolean): TypeAdapter[] {
    return [
      {
        name: 'string',
        // eslint-disable-next-line react/display-name
        render: (field) => {
          const props = { ...field.props };
          // const multilingual = props.multilingual;
          delete props.type;
          if (props.prefixIcon) {
            // props.prefix = (
            //   <LegacyIcon type={props.prefixIcon} style={{ color: 'rgba(0,0,0,.25)' }} />
            // );
            delete props.prefixIcon;
          }
          delete props.multilingual;
          // if (multilingual === true) {
          //   return <MultiLanguageLineInput {...props} />;
          // }
          return <Input {...props} />;
        },
      },
      {
        name: 'richText',
        render: (field) => {
          const props = { ...field.props };
          // const multilingual = props.multilingual;
          delete props.type;
          if (props.prefixIcon) {
            // props.prefix = (
            //   <LegacyIcon type={props.prefixIcon} style={{ color: 'rgba(0,0,0,.25)' }} />
            // );
            delete props.prefixIcon;
          }
          delete props.multilingual;
          // if (multilingual === true) {
          //   return <MultiLanguageLineInput {...props} />;
          // }
          return <RichText {...props} />;
        },
      },
      {
        name: 'text',
        // eslint-disable-next-line react/display-name
        render: (field) => {
          const props = { ...field.props };
          if (field.props === undefined) {
            field.props = {};
          }
          if (field.props.autosize === undefined) {
            field.props.autosize = { minRows: 2, maxRows: 10 };
          }
          // const multilingual = props.multilingual;
          delete props.multilingual;
          delete props.type;
          // if (multilingual) {
          //   return <MultiLanguageTextInput {...props} />;
          // }
          return <TextArea {...props} />;
        },
      },
      // {
      //   name: 'json',
      //   // eslint-disable-next-line react/display-name
      //   render: (field) => {
      //     return <JsonEditor {...field.props} />;
      //   }
      // },
      // {
      //   name: 'address',
      //   // eslint-disable-next-line react/display-name
      //   render: (field) => {
      //     return <AddressPicker {...field.props} />;
      //   }
      // },
      {
        name: 'number',
        // eslint-disable-next-line react/display-name
        render: (field) => {
          return <InputNumber style={{ display: 'block', width: '100%' }} {...field.props} />;
        },
      },
      {
        name: 'hidden',
        // eslint-disable-next-line react/display-name
        render: (field) => {
          return <input type="hidden" {...field.props} />;
        },
      },
      {
        name: 'label',
        // eslint-disable-next-line react/display-name
        render: (field) => {
          return <span {...field.props}>{field.props.text}</span>;
        },
      },
      {
        name: 'password',
        // eslint-disable-next-line react/display-name
        render: (field) => {
          const props = { ...field.props };
          delete props.type;
          if (props.prefixIcon) {
            // props.prefix = (
            //   <LegacyIcon type={props.prefixIcon} style={{ color: 'rgba(0,0,0,.25)' }} />
            // );
            delete props.prefixIcon;
          }
          return <Input.Password {...props} />;
        },
      },
      // {
      //   name: 'passwordInput',
      //   // eslint-disable-next-line react/display-name
      //   render: (field) => {
      //     constant props = { ...field.props };
      //     delete props.type;
      //     if (props.prefixIcon) {
      //       props.prefix = <LegacyIcon type={props.prefixIcon} style={{ color: 'rgba(0,0,0,.25)' }} />;
      //       delete props.prefixIcon;
      //     }
      //     return <PasswordInput {...props} />;
      //   },
      // },
      {
        name: 'email',
        // eslint-disable-next-line react/display-name
        render: (field) => {
          const props = { ...field.props };
          delete props.type;
          if (props.prefixIcon) {
            // props.prefix = (
            //   <LegacyIcon type={props.prefixIcon} style={{ color: 'rgba(0,0,0,.25)' }} />
            // );
            delete props.prefixIcon;
          }
          return <Input type={'email'} {...props} />;
        },
      },
      {
        name: 'date',
        // eslint-disable-next-line react/display-name
        render: (field) => {
          // delete field?.props?.type;
          // delete field?.props?.values;
          // field.props.format = 'DD/MM/YYYY';
          return (
            <ConverterComponent
              encode={(value: any) => (value ? value.format('YYYY-MM-DD') : value)}
              decode={(value: any) => (value ? dayjs(value) : value)}
              component={DatePicker}
              disabledDate={field.props?.disabledDate}
              {...field.props}
            />
          );
        },
      },
      {
        name: 'radio',
        // eslint-disable-next-line react/display-name
        render: (field) => {
          const { values } = field.props;
          if (values instanceof Array) {
            return (
              <Radio.Group {...field.props}>
                {values.map((value: any, index) => {
                  if (typeof value === 'string') {
                    return (
                      <Radio.Button key={index} value={value}>
                        {value}
                      </Radio.Button>
                    );
                  } else {
                    return (
                      <Radio.Button key={index} value={value.key}>
                        {value.value}
                      </Radio.Button>
                    );
                  }
                })}
              </Radio.Group>
            );
          }
          return (
            <Radio.Group {...field.props}>
              {Object.keys(values).map((value, index) => (
                <Radio key={index} value={value}>
                  {values[value]}
                </Radio>
              ))}
            </Radio.Group>
          );
        },
      },
      {
        name: 'checkBox',
        // eslint-disable-next-line react/display-name
        render: (field) => {
          return <Checkbox.Group {...field.props} />;
        },
      },
      {
        name: 'boolean',
        // eslint-disable-next-line react/display-name
        render: (field) => {
          return <BooleanInput {...field.props} />;
        },
      },
      {
        name: 'search',
        // eslint-disable-next-line react/display-name
        render: (field) => {
          return <Input.Search {...field.props} />;
        },
      },
      // {
      //   name: 'template',
      //   // eslint-disable-next-line react/display-name
      //   render: (field) => {
      //     return <HtmlTemplateInput {...field.props} />;
      //   }
      // },
      {
        name: 'select',
        // eslint-disable-next-line react/display-name
        render: (field) => {
          const { values } = field.props;
          if (values instanceof Array) {
            return (
              <Select style={{ display: 'block' }} {...field.props}>
                {values.map((value: any, index) => (
                  <Select.Option key={index} value={value}>
                    {value}
                  </Select.Option>
                ))}
              </Select>
            );
          }
          return (
            <Select style={{ display: 'block' }} {...field.props}>
              {Object.keys(values).map((value, index) => (
                <Select.Option key={index} value={value}>
                  {values[value]}
                </Select.Option>
              ))}
            </Select>
          );
        },
      },
      {
        name: 'selectStatus',
        // eslint-disable-next-line react/display-name
        render: (field) => <SelectStatus {...field.props} />,
      },
      {
        name: 'dateRange',
        // eslint-disable-next-line react/display-name
        render: (field) => {
          field.props.format = 'DD/MM/YYYY';
          return (
            <ConverterComponent
              encode={(value: any) =>
                value ? value.map((val: any) => (val ? val.format('YYYY-MM-DD') : val)) : value
              }
              decode={(value: any) =>
                value ? value.map((val: string) => (val ? dayjs(val) : val)) : value
              }
              component={DatePicker.RangePicker}
              {...field.props}
            />
          );
        },
      },
      {
        name: 'selectSearch',
        // eslint-disable-next-line react/display-name
        render: (field) => {
          return <SelectSearch {...field.props} />;
        },
      },
      {
        name: 'enum',
        // eslint-disable-next-line react/display-name
        render: (field) => {
          return <EnumLoader {...field.props} />;
        },
      },
      {
        name: 'image',
        // eslint-disable-next-line react/display-name
        render: (field) => {
          return <ImageUploader {...field.props} />;
        },
      },
      {
        name: 'file',
        // eslint-disable-next-line react/display-name
        render: (field) => {
          return <FileUpload {...field.props} />;
        },
      },
      {
        name: 'cropped-image',
        // eslint-disable-next-line react/display-name
        render: (field) => {
          return <CroppedImageUploader {...field.props} />;
        },
      },
      {
        name: 'avatar',
        // eslint-disable-next-line react/display-name
        render: (field) => {
          return <AvatarUploader {...field.props} />;
        },
      },
      // {
      //   name: 'images',
      //   // eslint-disable-next-line react/display-name
      //   render: (field) => {
      //     return <ImagesInput allowAdd={true} deletable={true} {...field.props} />;
      //   }
      // },
      // {
      //   name: 'location',
      //   // eslint-disable-next-line react/display-name
      //   render: (field) => {
      //     return <LocationPicker {...field.props} />;
      //   }
      // },
      // {
      //   name: 'phone',
      //   // eslint-disable-next-line react/display-name
      //   render: (field) => {
      //     return <PhoneInputEx {...field.props} />;
      //   }
      // },
      {
        name: 'switch',
        // eslint-disable-next-line react/display-name
        render: (field) => {
          return <Switch {...field.props} />;
        },
      },
      // {
      //   name: 'enum',
      //   // eslint-disable-next-line react/display-name
      //   render: (field) => {
      //     return <EnumInput {...field.props} />;
      //   }
      // },
      // {
      //   name: 'enum-async',
      //   // eslint-disable-next-line react/display-name
      //   render: (field) => {
      //     return <SelectInputAsync {...field.props} enum={field.props.enum} />;
      //   },
      // },
      {
        name: 'autocomplete',
        // eslint-disable-next-line react/display-name
        render: (field) => {
          return <AutoCompleteInput {...field.props} />;
        },
      },
      {
        name: 'template',
        // eslint-disable-next-line react/display-name
        render: (field) => {
          return <HtmlTemplateInput {...field.props} />;
        },
      },
      // {
      //   name: 'user',
      //   // eslint-disable-next-line react/display-name
      //   render: (field) => {
      //     return <UserSelect {...field.props} enum={field.props.enum} />;
      //   }
      // },
      // {
      //   name: 'supplier',
      //   // eslint-disable-next-line react/display-name
      //   render: (field) => {
      //     return <SupplierSelect {...field.props} enum={field.props.enum} />;
      //   }
      // }
      // {
      //   name: 'template',
      //   render: (field) => {
      //     return <HtmlTemplateInput {...field.props} />;
      //   },
      // },
      // {
      //   name: 'country',
      //   render: (field) => {
      //     return <CountrySelect {...field.props} />;
      //   },
      // },
      // {
      // {
      //   name: 'month-range',
      //   render: (field) => {
      //     return <CustomizeMonthPicker {...field.props} />;
      //   },
      // },
      // {
      //   name: 'color',
      //   render: (field) => {
      //     return <ColorPicker {...field.props} />;
      //   },
      // },
    ];
  }

  static allValidators(): ValidationAdapter[] {
    return [
      {
        name: 'equals',
        message: 'Should be equals',
        validator: async (rule: any, value: any, form: FormInstance) => {
          if (form.getFieldValue(rule.to) !== value) {
            throw Error('Not equal');
          }
        },
      },
      {
        name: 'nic',
        message: 'Should be a valid NIC',
        validator: async (rule: any, value: any) => {
          if (value === undefined || value === '') {
            return;
          }
          const pattern = /^([0-9]{9}[x|X|v|V]|[0-9]{12})$/m;
          if (!value.match(pattern)) {
            throw Error('Not a NIC');
          }
          try {
            const datePart = value.substr(value.length === 10 ? 2 : 4, 3);
            let date = parseInt(datePart);
            if (date > 500) {
              date = date - 500;
            }
            if (date <= 0 || date > 366) {
              throw Error('Not a NIC');
            }
          } catch (e) {
            throw Error('Not a NIC');
          }
        },
      },
      {
        name: 'email',
        message: 'Should be valid E-mail',
        validator: async (rule: any, value: any) => {
          if (value === undefined || value === '') {
            return;
          }
          const pattern = /^[\w-.]+@([\w-]+\.)+[\w-]{2,8}$/g;
          if (!value.match(pattern)) {
            throw Error('Not a Valid E-mail');
          }
        },
      },
      {
        name: 'plusNumber',
        message: 'Should be Positive value',
        validator: async (rule: any, value: number) => {
          if (value === undefined || value === 0) {
            return;
          }
          if (+value < 0) {
            throw Error('Not a Positive Value');
          }
        },
      },
    ];
  }
}

// // tslint:disable-next-line:variable-name
// constant ReactQuillX = (props: any) => {
//   constant formats = [
//     // 'header',
//     'bold',
//     'italic',
//     'underline',
//     // 'strike',
//     'list',
//     'bullet',
//     'indent',
//     'link',
//     // 'color',
//     // 'background',
//   ];
//
//   constant modules = {
//     toolbar: [
//       // [{ header: [3, 4, 5, 6, false] }],
//       ['bold', 'italic', 'underline'],
//       // [{ color: [] }, { background: [] }],
//       [{ list: 'ordered' }, { list: 'bullet' }],
//       [{ indent: '-1' }, { indent: '+1' }],
//       ['link'],
//       ['clean'],
//     ],
//   };
//   constant value = props.value;
//   constant onChange = props.onChange;
//   constant p = { ...props };
//   delete p.value;
//   delete p.onChange;
//   return (
//     <ReactQuill
//       modules={modules}
//       value={value ? (value as string) : ''}
//       onChange={(content) => onChange && onChange(content)}
//       formats={formats}
//       {...p}
//     />
//   );
// };

export type MapPropsOptions = {
  map?: (props: any) => any;
  put?: Record<string, any>;
  remove?: string | string[];
  style?: CSSProperties;
  className?: string;
  encode?: (value: any) => any;
  decode?: (value: any) => any;
};

export const MapProps = (
  component: React.ComponentType,
  mapper: MapPropsOptions,
): React.ComponentType => {
  const Com = component;
  // tslint:disable-next-line:
  return (props) => {
    const newProps = useMemo(() => {
      const prps: any = mapper.put ? { ...mapper.put, ...props } : { ...props };
      if (mapper.remove) {
        if (Array.isArray(mapper.remove)) {
          mapper.remove.forEach((m) => delete prps[m]);
        } else {
          delete prps[mapper.remove];
        }
      }
      if (mapper.style) {
        prps.style = prps.style ? { ...mapper.style, ...prps.style } : mapper.style;
      }
      if (mapper.className) {
        prps.className = `${mapper.className} ${prps.className ?? ''}`.trim();
      }
      if (mapper.encode) {
        const onChange = prps.onChange;
        if (onChange) {
          prps.onChange = (value: any) => {
            if (value === undefined || value === null) {
              onChange(undefined);
            } else if (value.target !== undefined && value.target !== null) {
              onChange(
                value.target.value === undefined || value.target.value === null
                  ? undefined
                  : mapper.encode?.(value.target.value),
              );
            } else {
              onChange(mapper.encode?.(value));
            }
          };
        }
      }
      if (mapper.decode) {
        const value = prps.value;
        if (value !== undefined) {
          prps.value = mapper.decode(value);
        }
      }
      return mapper.map ? mapper.map(prps) : prps;
    }, [props]);
    return <Com {...newProps} />;
  };
};
